import React from 'react';
import { Grid, Card, CardActionArea, CardMedia, CardContent, Typography, Rating, CardActions, Button, Avatar, Box } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const reviewList = [
  {
    reviewer: 'Arun Kumar',
    review: 'The taxi service was punctual and the driver was very polite. Made my trip from Chennai to Coimbatore very comfortable.',
    rating: 4.5,
    date: '2023-10-10',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Chennai to Coimbatore'
  },
  {
    reviewer: 'Lakshmi R.',
    review: 'The ride from Madurai to Kodaikanal was smooth, and the driver was knowledgeable about the local area. Highly recommend this service!',
    rating: 4.0,
    date: '2023-10-09',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Madurai to Kodaikanal'
  },
  {
    reviewer: 'Vignesh S.',
    review: 'Excellent service! The taxi was clean, and the driver made sure we were comfortable throughout the journey from Trichy to Salem.',
    rating: 4.2,
    date: '2023-10-08',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Trichy to Salem'
  },
  {
    reviewer: 'Meena P.',
    review: 'The driver was friendly and professional. Enjoyed a safe and scenic ride from Coimbatore to Ooty. Highly satisfied!',
    rating: 4.8,
    date: '2023-10-07',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Coimbatore to Ooty'
  },
  {
    reviewer: 'Rajesh K.',
    review: 'The Chennai airport pickup was prompt. The driver was courteous and the car was spotless. Highly recommend!',
    rating: 4.7,
    date: '2023-10-06',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Chennai Airport Pickup'
  },
  {
    reviewer: 'Priya M.',
    review: 'We booked a taxi for a family trip from Erode to Tiruvannamalai. The driver was very considerate and patient with our stops.',
    rating: 4.6,
    date: '2023-10-05',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Erode to Tiruvannamalai'
  },
  {
    reviewer: 'Dinesh R.',
    review: 'Had a very comfortable experience traveling from Pondicherry to Chennai. The driver was punctual and professional.',
    rating: 4.3,
    date: '2023-10-04',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Pondicherry to Chennai'
  },
  {
    reviewer: 'Sita V.',
    review: 'The driver helped us navigate all the temples in Thanjavur. Very friendly and knowledgeable about the local attractions!',
    rating: 4.9,
    date: '2023-10-03',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Thanjavur Temple Tour'
  },
  {
    reviewer: 'Mani T.',
    review: 'Amazing ride from Salem to Yercaud. The driver ensured a safe and scenic drive up the hills. Great experience!',
    rating: 4.4,
    date: '2023-10-02',
    imageUrl: 'https://via.placeholder.com/50',
    service: 'Salem to Yercaud'
  }
];


const CarCards = () => {
  const isLargeScreen = true; // Example for class logic

  return (
    <Grid container spacing={3}> {/* Adjust the spacing prop here */}
      {reviewList.map((car, index) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={index}> {/* Adjust breakpoints for responsiveness */}
          <Card sx={{ minWidth: 200, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} className={isLargeScreen ? "large-screen-reviews" : ""}>
            <CardActionArea>
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {car.reviewer}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {car.review}
                </Typography>
                <Rating
                  name="text-feedback"
                  value={car.rating}
                  readOnly
                  precision={0.5}
                  emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                />
              </CardContent>
            </CardActionArea>

            <CardActions sx={{ justifyContent: 'space-between', padding: '8px 16px' }}>
              {/* Bottom Left: Review Image and Icon */}
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Avatar src={car.imageUrl} alt="Reviewer Image" sx={{ width: 24, height: 24, marginRight: 1 }} />
                <AccountCircleIcon fontSize="small" />
              </Box>

              {/* Bottom Right: Created Date/Time */}
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {new Date(car.date).toLocaleDateString()}
              </Typography>
            </CardActions>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default CarCards;
